module.exports = __webpack_public_path__ + "static/media/gogig-career-desires.20b818cb.png";